<template>
  <div>
    <div class="header-a">
      <van-tabs type="card">
        <van-tab title="申请开票">
          <p class="a">请勾选可以进行开票的订单</p>
          <div class="order">
            <div class="select">
              <!-- <van-checkbox v-model="checked" icon-size="18px"> </van-checkbox> -->
              <input class="b" type="checkbox" />
            </div>
            <div>
              <p>停车缴费</p>
              <i>￥10</i>
            </div>
            <div>
              <p>缴费时间：2020-08-22 15:18:17</p>
            </div>
            <div>
              <p>可开票金额：¥ 10.00元</p>
            </div>
          </div>
          <div class="btn">
            <button class="btn btn-green" @click="link('/personal')">
              下一步
            </button>
          </div>
        </van-tab>
        <van-tab title="开票记录">
          <div class="record">
            <div>
              <p>2020-08-22 15:18:17</p>
            </div>
            <div>
              <h3>发票抬头</h3>
              <p>张三</p>
            </div>
            <div>
              <h3>消费类型</h3>
              <p>停车缴费</p>
            </div>
            <div>
              <h3>开票金额</h3>
              <p>¥10.00</p>
            </div>
          </div>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      checked: false,
    };
  },
  created() {},
  methods: {
    link(url) {
      this.$router.push(url);
    },
  },
};
</script>

<style scoped>
/deep/.van-tabs--card > .van-tabs__wrap {
  height: 100px;
}
/deep/.header-a .van-tabs__nav--card {
  height: 88px;
  margin: 0;
  border: 0;
}
/deep/.header-a .van-tab__text--ellipsis {
  overflow: visible;
  font-size: 33px;
}
/deep/.header-a .van-tabs__nav--card .van-tab.van-tab--active {
  background: #37C192;
  color: #fff;
}

/deep/.header-a .van-tabs__nav--card .van-tab {
  color: #999999;
  border-right: 0;
}

.header-a .a {
  margin: 40px;
  color: #999999;
  font-size: 33px;
}

.header-a .order {
  margin: 30px;
  height: 230px;
  background: #fff;
  box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
}

.header-a .order div {
  display: flex;
  justify-content: space-between;
}

.header-a .order p {
  margin: 0 30px;
  padding-top: 30px;
  width: 400px;
  float: left;
  font-size: 26px;
}

.header-a .order i {
  margin: 0 60px;
  padding-top: 15px;
  color: red;
  font-size: 50px;
}

.header-a .order .select {
  float: left;
  height: 50px;
  margin-left: 30px;
  margin-top: 100px;
}

.header-a .order .select .b {
  width: 30px;
  height: 30px;
}

.btn {
  margin-top: 500px;
  z-index: 10;
}

.record {
  background: #fff;
  height: 340px;
  margin: 30px;
}

.record div {
  display: flex;
  justify-content: space-between;
}

.record h3 {
  padding: 20px;
  padding-left: 50px;
  font-size: 33px;
}

.record p {
  padding: 20px;
  padding-left: 30px;
  font-size: 33px;
}
</style>


// WEBPACK FOOTER //
// src/pages/invoice.vue